import { render, staticRenderFns } from "./PeopleNumber.vue?vue&type=template&id=0d3fa382&scoped=true&"
import script from "./PeopleNumber.vue?vue&type=script&lang=js&"
export * from "./PeopleNumber.vue?vue&type=script&lang=js&"
import style0 from "./PeopleNumber.vue?vue&type=style&index=0&id=0d3fa382&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3fa382",
  null
  
)

export default component.exports